import { EventEmitter, Injector, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AccessoryCategory, Constants, Positions, PositionValues } from '../../core/Constants';
import { GenericSummaryCardDtoResponse } from '../../core/models/generic-summary-card.dto-response';
import { HardwareCategoryCards } from '../../core/models/hardware-category-cards';
import { PackageBuilderSummaryProduct } from '../../core/models/package-builder-summary-product.model';
import { ProductCardDtoResponse } from '../../core/models/product-card-dto-response';
import { Product } from '../../core/models/product.model';
import { RouteContext } from '../../core/models/route-context';
import { PackageBuilderService } from '../../package-builder/package-builder.service';
import { HardwareService } from '../hardware.service';
import { Helper } from '../helper';
import { IProductService } from '../iproduct.service';
import { SearchTextService } from '../search-text.service';
import { SettingService } from '../setting.service';
import { ProductNotesService } from '../notes/product-notes.service';
import { WarningsSetupService } from '../notes/warnings-setup.service';
import { Subscription } from 'rxjs';
import { User } from '../../core/User';
import { LabourModel } from 'app/shared/notes/models/labour-model';
import { LabourDetailsDtoResponse } from 'app/core/models/labour-details.dto-response';
import { AddToCartService } from '../add-to-cart.service';
import { PackageKitService } from '../packagekit.service';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { HardwareAlternateOptionModalComponent } from './hardware-alternate-option-modal/hardware-alternate-option-modal.component';
import { LeadTimeDtoResponse } from '../../core/models/lead-time-dto-response';

export class HardwareSelectorBaseComponent implements OnInit,OnDestroy {
	@Input() hardware: ProductCardDtoResponse;
	@Input() card: GenericSummaryCardDtoResponse;
  @Input() keys: GenericSummaryCardDtoResponse[];
  @Input() alternateProducts: GenericSummaryCardDtoResponse[];
  @Input() minQuantity: number;
  @Input() mtlWheelDrillLeadTime: LeadTimeDtoResponse;

	@Output() selectProductComplete = new EventEmitter();
	@Output() productRemoved = new EventEmitter();
  @Output() prodSelectorQtyChanged = new EventEmitter<number>();

  protected translateService: TranslateService;

	isInPackageBuilder: boolean;
	isSelectedProduct: boolean;
	context: RouteContext;
	packageBuilderService: PackageBuilderService;
	productService: IProductService;

  qty: number;
  rearQty: number;
	frontWheelQty: number;
  rearWheelQty: number;
  frontTireQty: number;
  rearTireQty: number;
	totalRetail: number;
	totalPrice: number;
  stepQty: number; 
  frontPosition: Positions;
  rearPosition: Positions;

	separatedProducts: HardwareCategoryCards[];
  subs: Subscription[] = [];

  mountingAdded: boolean = false;
  isOptionalKey: boolean = null;

  constructor(
    private injector: Injector,
    private route: ActivatedRoute,
    private settingService: SettingService,
    private productNotesService: ProductNotesService,
    private addToCartService: AddToCartService,
    public modalService: NgbModal,
    public modalConfig: NgbModalConfig) {
    this.translateService = injector.get(TranslateService);
    this.qty = 1;
    this.minQuantity = 1;
    this.stepQty = 1;
  }

  ngOnInit() {
    this.frontPosition = Positions.FRONT;
    this.rearPosition = Positions.REAR;

    //this.keys = this.getKeyCards(this.card.keys);
    this.subs.push(this.route.data.subscribe(data => {
      this.context = data.context;
      if (this.context === RouteContext.PACKAGE_BUILDER && this.card.productType != 'Kit') {
        this.isInPackageBuilder = true;
        this.packageBuilderService = this.injector.get<PackageBuilderService>(PackageBuilderService);
        this.subs.push(this.packageBuilderService.onPackageChange.subscribe(pbModel => {
          if (!this.frontWheelQty && pbModel.front.wheel) {
            this.frontWheelQty = pbModel.front.wheel.quantity;
          }
          if (!this.rearWheelQty && pbModel.rear && pbModel.rear.wheel) {
            this.rearWheelQty = pbModel.rear.wheel.quantity;
          }
          if (!this.frontTireQty && pbModel.front.tire) {
            this.frontTireQty = pbModel.front.tire.quantity;
          }
          if (!this.rearTireQty && pbModel.rear && pbModel.rear.tire) {
            this.rearTireQty = pbModel.rear.tire.quantity;
          }
          let allHardware = pbModel.front.hardwares;
          allHardware = allHardware.concat(pbModel.rear.hardwares);

          const category = this.hardware.details.details.find(d => d.label === 'Type').accessoryType;
          let selectedIndex = new Array<number>();
          if (allHardware.length > 0) {
            if (this.hardware.pairNo != null && this.hardware.pairNo.length > 0) {
              allHardware.map(hardware => ({ id: hardware != null ? hardware.id : '', pairNo: hardware != null ? hardware.pairNo : '', catId: hardware.category }))
                .forEach((h, i) => {
                  if (h.pairNo === this.hardware.pairNo && h.catId === this.hardware.details.details.find(d => d.label === 'Type').accessoryType)
                    selectedIndex.push(i);
                });
            }
            else {
              let index = allHardware.map(hardware => hardware != null ? hardware.id : '').indexOf(this.hardware.longSKU);
              if (index !== -1)
                selectedIndex.push(index);
              if (this.card.rearProduct && category === AccessoryCategory.Mounting) {
                index = allHardware.map(hardware => hardware != null ? hardware.id : '').indexOf(this.card.rearProduct.longSKU);
                if (index !== -1)
                  selectedIndex.push(index);
              }
            }
          }

          if (selectedIndex.length > 0) {
            this.isSelectedProduct = true;
            this.qty = allHardware[selectedIndex[0]].quantity;
            this.rearQty = this.card.rearProduct ? this.qty : 0;
            if (this.card.rearProduct && category === AccessoryCategory.Mounting && selectedIndex.length > 1)
              this.rearQty = allHardware[selectedIndex[1]].quantity;
            this.totalRetail = this.qty * parseFloat(this.hardware.retailPrice);
            this.totalPrice = this.qty * parseFloat(this.hardware.customerPrice);
          } else {
            this.isSelectedProduct = false;
            if (category === AccessoryCategory.Mounting) {
              this.qty = (this.frontWheelQty >= this.frontTireQty ? this.frontTireQty : this.frontWheelQty);
              if (this.rearWheelQty) {
                if (this.rearTireQty)
                  this.rearQty = (this.rearWheelQty >= this.rearTireQty ? this.rearTireQty : this.rearWheelQty);
                else
                  this.rearQty = this.rearWheelQty;
              }
              else { //When Same Wheel Around all the Corner but Different TireOD 
                if (this.rearTireQty)
                  this.qty += this.rearTireQty;
              }
              if (this.rearQty && !this.card.rearProduct)
                this.qty += this.rearQty;
            }
            else {
              this.qty = this.minQuantity;
              this.rearQty = this.card.rearProduct ? this.qty : 0;
            }
          }
        }, Helper.handleError));
      } else if (this.context === RouteContext.PRODUCTS_BY_SPEC) {
      }

      this.setProductDefaultQuantity();
    }, Helper.handleError));
    this.createProductService();
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  private setProductDefaultQuantity() {
    if (this.context !== RouteContext.PACKAGE_BUILDER) {
      switch (this.card.frontProduct.accessoryType) {
        case AccessoryCategory.BilletWheelAdapters:
        case AccessoryCategory.Emblem:
        case AccessoryCategory.HubRings:
        case AccessoryCategory.WheelSpacers:
          this.qty = 4;
          break;
        case AccessoryCategory.TPMS:
          this.qty = 4;

          if (this.card.description.toLowerCase().includes('kit') && this.card.description.toLowerCase().includes('4x'))
            this.qty = 1;

          break;
        case AccessoryCategory.TireValves:
          this.qty = 4;
          if (this.card.frontProduct.qtyBaseUOfM > 1) {
            this.qty = 1;
          }
          if (this.card.description.toLowerCase().includes('pkg')) {
            this.qty = 1;
          }
          break;
        case AccessoryCategory.SpecialValves:
        case AccessoryCategory.ValveCap:
        case AccessoryCategory.Inserts:
          this.qty = 4;

          if (this.card.frontProduct.qtyBaseUOfM > 1)
            this.qty = 1;

          break;
        case AccessoryCategory.Bolts:
        case AccessoryCategory.Nuts:
        case AccessoryCategory.NutsET:
          this.qty = 20;
          break;
      }

      if (this.card.rearProduct == null && (this.card.productTypeWarning === 'Tire' || this.card.productTypeWarning === 'Wheel'))
        this.qty = 4;
    }
  }

  updateProduct() {
    if (this.context === RouteContext.PACKAGE_BUILDER && this.isSelectedProduct) {
      const product = this.createProduct();
      const position = this.hardwarePosition();

      this.packageBuilderService.updateHardware(product, this.hardwareSummary(product.quantity), position);
    }
	}

  updateProductByPosition(position: Positions) {
    if (this.context === RouteContext.PACKAGE_BUILDER) {
      if (position === Positions.REAR) {
        const rearProduct = this.createRearProduct();
        const qty = rearProduct.quantity;
        this.prodSelectorQtyChanged.emit(qty);
      }
      else {
        const product = this.createProduct();
        const qty = product.quantity;
        this.prodSelectorQtyChanged.emit(qty);
      }
      if (this.isSelectedProduct) {
        if (position === Positions.REAR) {
          const rearProduct = this.createRearProduct();

          const qty = rearProduct.quantity;
          this.prodSelectorQtyChanged.emit(qty);

          this.packageBuilderService.updateHardware(rearProduct, this.rearHardwareSummary(rearProduct.quantity), position);
        }
        else {
          const product = this.createProduct();
          const qty = product.quantity;
          this.prodSelectorQtyChanged.emit(qty);
          this.packageBuilderService.updateHardware(product, this.hardwareSummary(product.quantity), position);
        }
      }
      
    }
  }

	hardwarePosition(): Positions {
		return this.hardware.position === PositionValues.REAR ? Positions.REAR : Positions.FRONT;
	}

	buttonDisabled(): boolean {
		if (this.card.frontProduct.details.details.some(d => d.accessoryType === AccessoryCategory.CenterCaps)) {
			if (this.card.type.toLowerCase().startsWith('std')) {
				return true;
			}
		}
		return false;
  }

  get qtybuttonDisabled(): boolean {
    if (this.card.frontProduct.details.details.some(d => d.accessoryType === AccessoryCategory.Mounting))
      return true;
    return false;
  }

  buttonGrayedOut(): boolean {
    if (this.card.frontProduct.details.details.some(d => d.accessoryType === AccessoryCategory.CenterCaps)) {
      return sessionStorage.getItem("ExtensionCap") === "yes" && this.card.type != null && this.card.type.toLowerCase() !== "ext";
    }
    else
      return false;
  }

  async selectHardware() {
    let product = this.createProduct();
    const rearProduct = this.createRearProduct();
    const position = this.hardwarePosition();
    if (product.category === AccessoryCategory.Mounting || product.category === AccessoryCategory.Studding) {
      product.id = this.hardware.longSKU;
      const productArray = [];
      let labourProduct = this.createProduct();
      if (labourProduct.category === AccessoryCategory.Mounting)
        labourProduct.type = Constants.LABOUR_TYPE_MOUNTING_AND_BALANCING;
      if (labourProduct.category === AccessoryCategory.Studding)
        labourProduct.type = Constants.LABOUR_TYPE_STUDDING;
      productArray.push(labourProduct);
      this.packageBuilderService.addTheLabours(productArray, position);

      if (rearProduct) {
        const rearProductArray = [];
        let rearLabourProduct = this.createRearProduct();
        if (rearLabourProduct.category === AccessoryCategory.Mounting)
          rearLabourProduct.type = Constants.LABOUR_TYPE_MOUNTING_AND_BALANCING;
        if (rearLabourProduct.category === AccessoryCategory.Studding)
          rearLabourProduct.type = Constants.LABOUR_TYPE_STUDDING;
        rearProductArray.push(rearLabourProduct);
        this.packageBuilderService.addTheLabours(rearProductArray, Positions.REAR);
      }
    }

    if (this.packageBuilderService) {
      if (product.category === AccessoryCategory.Nuts || product.category === AccessoryCategory.Bolts) {
        this.packageBuilderService.keysRequired = this.keys != null && this.keys.length > 0
          && ((this.packageBuilderService.differentBoltNutHex(this.hardware.details.details.find(d => d.label === Constants.DetailLabelHex).value))
            || (!this.packageBuilderService.wheelIsDirectFit));
        document.getElementById('key').textContent = this.translateService
          .instant(Helper.renameKeyTab(this.packageBuilderService.keysRequired));
      }

      // Optional Key backorder validation
      this.isOptionalKey = null;
      this.packageBuilderService.showSkip = false;
      if (product.category === AccessoryCategory.Keys && !this.packageBuilderService.keysRequired) {
        this.isOptionalKey = true;
        this.card.frontProduct['isOptionalKey'] = this.isOptionalKey;

        // Show Skip button in warning message if the Optional Key is backordered
        this.packageBuilderService.showSkip = true;
      } // End

      const hardwareDetails = this.hardware.details.details;
      //if (product.category === AccessoryCategory.WheelLocks
      if ((product.category === AccessoryCategory.LockBolts
        || product.category === AccessoryCategory.LockNuts
        || product.category === AccessoryCategory.LockNutsET)
        && this.packageBuilderService.differentLockHex(this.hardwareSummary(product.quantity).description, hardwareDetails, 'hex')) {
        if (await this.packageBuilderService.validateWarnings(
          [this.packageBuilderService.getTranslatedNote('FC.Popup.DifferentHexLock')])) {
          if (product.warningNotes == null) {
            product.warningNotes = [];
          }
          product.warningNotes.push(this.packageBuilderService.getTranslatedNote('FC.Popup.DifferentHexLock'));
          this.packageBuilderService.updateHardware(product, this.hardwareSummary(product.quantity), position);
          //this.selectProductComplete.emit();
          this.raiseSelecteProductComplete(this.hardware);
        } else {
          //didn't pass wheel lock warning note check

        }
      } else if (product.category === AccessoryCategory.Mounting) {
        const mountingLeadTime = await this.settingService.getMountingLeadTime().first().toPromise();
        //const leadTimeUOM = mountingLeadTime.substring(mountingLeadTime.length - 1);
        //const leadTimeValue = mountingLeadTime.substring(0, mountingLeadTime.length - 1);
        const warning = Helper.stringFormat(this.translateService.instant('FC.Popup.MountingDelay'), mountingLeadTime.value, this.translateService.instant(`FC.LeadTime.${mountingLeadTime.unitOfMeasure}`));

        if (await this.packageBuilderService.validateWarnings([warning])) {
          this.mountingAdded = true;
          this.packageBuilderService.updateHardware(product, this.hardwareSummary(product.quantity), position);
          if (rearProduct)
            this.packageBuilderService.updateHardware(rearProduct, this.rearHardwareSummary(rearProduct.quantity), Positions.REAR);
          //this.selectProductComplete.emit();
          this.raiseSelecteProductComplete(this.hardware);
        }
      } else if (product.category === AccessoryCategory.Studding) {
        const studdingLeadTime = await this.settingService.getStuddingLeadTime().first().toPromise();
        //const leadTimeUOM = studdingLeadTime.substring(studdingLeadTime.length - 1);
        //const leadTimeValue = studdingLeadTime.substring(0, studdingLeadTime.length - 1);
        const warning = Helper.stringFormat(this.translateService.instant('FC.Popup.StuddingDelay'), studdingLeadTime.value, this.translateService.instant(`FC.LeadTime.${studdingLeadTime.unitOfMeasure}`));

        if (await this.packageBuilderService.validateWarnings([warning])) {
          this.packageBuilderService.updateHardware(product, this.hardwareSummary(product.quantity), position);
          if (rearProduct)
            this.packageBuilderService.updateHardware(rearProduct, this.rearHardwareSummary(rearProduct.quantity), Positions.REAR);
          //this.selectProductComplete.emit();
          this.raiseSelecteProductComplete(this.hardware);
        }
      } else if (product.category === AccessoryCategory.TPMS) {
        this.packageBuilderService.valvesRequired = this.card.valveNumber === "Required";
        let warningsList = null;
        WarningsSetupService.setupWarnings(this.packageBuilderService, this.translateService, this.settingService, this.qty, this.rearQty, this.card, this.context === RouteContext.PACKAGE_BUILDER || this.context === RouteContext.SEARCH_BY_VEHICLE || this.context === RouteContext.SEARCH_BY_VEHICLE_FOR_ACCESSORY, false, this.mtlWheelDrillLeadTime).then(value => {
          warningsList = value;
          this.packageBuilderService.validateWarnings(warningsList.warnings).then(validated => {
            if (validated && warningsList.proceedToNextStep) {
              if (product.warningNotes == null) {
                product.warningNotes = [];
              }
              if (this.card.frontProduct.warningNotes != null) {
                this.card.frontProduct.warningNotes.forEach(note => {
                  if (!product.warningNotes.some(n => n === note))
                    product.warningNotes.push(note);
                });
              }
              this.packageBuilderService.updateHardware(product, this.hardwareSummary(product.quantity), position);
              if (rearProduct)
                this.packageBuilderService.updateHardware(rearProduct, this.rearHardwareSummary(rearProduct.quantity), Positions.REAR);
              //this.selectProductComplete.emit();
              this.raiseSelecteProductComplete(this.hardware);
            }
          });
        });
      }
      else {
        let warningsList = null;
        WarningsSetupService.setupWarnings(this.packageBuilderService, this.translateService, this.settingService, this.qty, this.rearQty, this.card, this.context === RouteContext.PACKAGE_BUILDER || this.context === RouteContext.SEARCH_BY_VEHICLE || this.context === RouteContext.SEARCH_BY_VEHICLE_FOR_ACCESSORY, false, this.mtlWheelDrillLeadTime).then(value => {
          warningsList = value;
          this.packageBuilderService.validateWarnings(warningsList.warnings).then(validated => {
            if (validated && warningsList.proceedToNextStep) {
              if (product.warningNotes == null) {
                product.warningNotes = [];
              }
              if (this.card.frontProduct.warningNotes != null) {
                this.card.frontProduct.warningNotes.forEach(note => {
                  if (!product.warningNotes.some(n => n === note))
                    product.warningNotes.push(note);
                });
              }
              if ((product.category === AccessoryCategory.Nuts || product.category === AccessoryCategory.Bolts) && warningsList.showAlternateOptionsForBackOrder === true) {
                const modalRef = this.modalService.open(HardwareAlternateOptionModalComponent, { windowClass: 'fastco-modal', size: 'lg', backdrop: 'static', keyboard: false });
                modalRef.componentInstance.product = product;
                modalRef.componentInstance.minQuantity = this.qty;
                modalRef.componentInstance.defaultWarehouse = this.hardware.defaultWarehouse;
                modalRef.componentInstance.alternateProducts = this.alternateProducts;
                modalRef.componentInstance.alternateProductSelected.subscribe((value: ProductCardDtoResponse) => {
                  if (value) {
                    this.updateKeyTab(value);
                    this.raiseSelecteProductComplete(value);
                  }
                });
                modalRef.componentInstance.continueBackOrder.subscribe((value: boolean) => {
                  if (value && value === true) {
                    const message = this.packageBuilderService.getTranslatedNote('FC.Popup.BackorderOrNot');
                    this.productNotesService.validateProductWarningsAckNormalPopup([message], null, '', '').then(ack => {
                      if (ack) {
                        this.packageBuilderService.updateHardware(product, this.hardwareSummary(product.quantity), position);
                        if (rearProduct)
                          this.packageBuilderService.updateHardware(rearProduct, this.rearHardwareSummary(rearProduct.quantity), product.category === AccessoryCategory.CenterCaps ? position : Positions.REAR);
                        //this.selectProductComplete.emit();
                        this.raiseSelecteProductComplete(this.hardware);
                      }
                    });
                  }
                });
              }
              else {
                this.packageBuilderService.updateHardware(product, this.hardwareSummary(product.quantity), position);
                if (rearProduct)
                  this.packageBuilderService.updateHardware(rearProduct, this.rearHardwareSummary(rearProduct.quantity), product.category === AccessoryCategory.CenterCaps ? position : Positions.REAR);
                //this.selectProductComplete.emit();
                this.raiseSelecteProductComplete(this.hardware);
              }
            }
          });
        });
      }
    }
  }
  private updateKeyTab(hd: ProductCardDtoResponse) {
    const alternateProductKeys = this.alternateProducts.find(p => p.frontProduct.longSKU === hd.longSKU).keys;
    this.packageBuilderService.keysRequired = alternateProductKeys != null && alternateProductKeys.length > 0
      && ((this.packageBuilderService.differentBoltNutHex(hd.details.details.find(d => d.label === Constants.DetailLabelHex).value))
        || (!this.packageBuilderService.wheelIsDirectFit));
    document.getElementById('key').textContent = this.translateService
      .instant(Helper.renameKeyTab(this.packageBuilderService.keysRequired));
  }
  private raiseSelecteProductComplete(hd: ProductCardDtoResponse) {
    const accType = hd.details.details.find(d => d.label === 'Type').accessoryType;
    if (accType === AccessoryCategory.Nuts || accType === AccessoryCategory.Bolts)
      this.packageBuilderService.removeKey();
    this.selectProductComplete.emit({
      longSKU: hd.longSKU,
      accessoryType: accType,
      category: hd.details.details.find(d => d.label === 'Type').value,
      selected: true
    });
  }
 
  async removeHardware() {
    const position = this.hardware.position === PositionValues.REAR ? Positions.REAR : Positions.FRONT;
    const product = this.createProduct();
    const rearProduct = this.createRearProduct();

    this.totalRetail = 0;
    this.totalPrice = 0;

    if (this.packageBuilderService) {
      if (product.category === AccessoryCategory.Nuts) {
        this.packageBuilderService.keysRequired = false;
      } else if (product.category === AccessoryCategory.TPMS) {
        this.packageBuilderService.valvesRequired = false;
      }
      this.packageBuilderService.removeHardware(product, this.hardwareSummary(product.quantity), position);

      if (rearProduct) {
        this.packageBuilderService.removeHardware(rearProduct, this.rearHardwareSummary(rearProduct.quantity), product.category === AccessoryCategory.CenterCaps ? position : Positions.REAR);
      }

      if (product.category === AccessoryCategory.Mounting) {
        this.packageBuilderService.removeSideWallType(position);
        this.packageBuilderService.deselectLabour(product);
      }

      //djb:bug-setting the qty to zero allowed the product to be added to the summary with 0 qty,
      //this.qty = 0;
      this.qty = this.minQuantity;

      // remove all keys
      if (product.category === AccessoryCategory.Bolts || product.category === AccessoryCategory.Nuts) {
        if (this.keys != null) {
          this.keys.forEach(k => {
            const keyProduct = new Product({
              id: k.frontProduct.longSKU,
              quantity: 0,
              warningNotes: null,
              type: Constants.PRODUCT_TYPE_HARDWARE,
              category: AccessoryCategory.Keys,
              pairNo: k.pairNo
            });
            const keySummaryProduct = new PackageBuilderSummaryProduct();
            keySummaryProduct.shortSKU = k.frontProduct.shortSKU;
            keySummaryProduct.qty = 0;
            keySummaryProduct.accessoryType = AccessoryCategory.Keys;
            keySummaryProduct.pairNo = k.pairNo;
            this.packageBuilderService.removeHardware(keyProduct, keySummaryProduct, Positions.FRONT);
          });
        }
      }
      // update session variable
      else if (product.category === AccessoryCategory.CenterCaps && this.card.type.toLowerCase() === "ext") {
        sessionStorage.setItem("ExtensionCapRemovedByUser", "yes");
      }
    }

    //signal parent component that product was de-selected/removed
    this.productRemoved.emit();

  }

	createProduct(): Product {
		// djb:bug-added original qty to decrement wheel locks
		return new Product({
			id: this.hardware.longSKU,
			quantity: this.qty,
			originalQty: this.qty,
			warningNotes: this.hardware.warningNotes,
			type: Constants.PRODUCT_TYPE_HARDWARE,
      category: this.hardware.details.details.find(d => d.label === 'Type').accessoryType,
      pairNo: this.hardware.pairNo,
      position: this.hardware.position !== null ? this.hardware.position.toString() : null,
      freeWMB: this.hardware.freeWMB,
      wmbRequired: this.card.wmbRequired
		});
	}

  createRearProduct(): Product {
    // djb:bug-added original qty to decrement wheel locks
    if ((this.card.rearProduct))
      return new Product({
        id: this.card.rearProduct.longSKU,
        quantity: this.rearQty,
        originalQty: this.rearQty,
        warningNotes: this.card.rearProduct.warningNotes,
        type: Constants.PRODUCT_TYPE_HARDWARE,
        category: this.card.rearProduct.details.details.find(d => d.label === 'Type').accessoryType,
        pairNo: this.card.pairNo,
        position: this.card.rearProduct.position !== null ? this.card.rearProduct.position.toString() : null,
        freeWMB: this.card.rearProduct.freeWMB,
        wmbRequired: this.card.wmbRequired
      });
    else
      return null;
  }

  hardwareSummary(qty: number): PackageBuilderSummaryProduct {
    const summaryProduct = new PackageBuilderSummaryProduct();
    summaryProduct.imgURL = this.hardware.productImage.imageUrl;
    summaryProduct.description = this.hardware.title;
    summaryProduct.shortSKU = this.hardware.shortSKU;
    summaryProduct.longSKU = this.hardware.longSKU;
    summaryProduct.qty = qty;// this.qty;
    summaryProduct.retailPrice = parseFloat(this.hardware.retailPrice);
    summaryProduct.customerPrice = parseFloat(this.hardware.customerPrice);
    summaryProduct.landedCost = parseFloat(this.hardware.landedCost);
    summaryProduct.totalPrice = parseFloat(this.hardware.customerPrice) * qty;
    summaryProduct.accessoryType = this.hardware.details.details.find(d => d.label === 'Type').accessoryType;
    summaryProduct.warningNotes = this.card.frontProduct.warningNotes;
    summaryProduct.pairNo = this.card.pairNo;
    if (this.hardware.position !== null)
      summaryProduct.position = this.hardware.position.toString();
    return summaryProduct;
  }

  rearHardwareSummary(qty: number): PackageBuilderSummaryProduct {
    if ((this.card.rearProduct)) {
      const summaryProduct = new PackageBuilderSummaryProduct();
      summaryProduct.imgURL = this.card.rearProduct.productImage.imageUrl;
      summaryProduct.description = this.card.rearProduct.title;
      summaryProduct.shortSKU = this.card.rearProduct.shortSKU;
      summaryProduct.longSKU = this.card.rearProduct.longSKU;
      summaryProduct.qty = qty;// this.rearQty;
      summaryProduct.retailPrice = parseFloat(this.card.rearProduct.retailPrice);
      summaryProduct.customerPrice = parseFloat(this.card.rearProduct.customerPrice);
      summaryProduct.landedCost = parseFloat(this.card.rearProduct.landedCost);
      summaryProduct.totalPrice = parseFloat(this.card.rearProduct.customerPrice) * qty;
      summaryProduct.accessoryType = this.card.rearProduct.details.details.find(d => d.label === 'Type').accessoryType;
      summaryProduct.warningNotes = this.card.rearProduct.warningNotes;
      summaryProduct.pairNo = this.card.pairNo;
      if (this.card.rearProduct.position !== null)
        summaryProduct.position = this.card.rearProduct.position.toString();
      return summaryProduct;
    }
    else
      return null;
  }

  async addProductToCart() {
    let warningsList = null;
    WarningsSetupService.setupWarnings(null, this.translateService, this.settingService, this.qty, this.rearQty, this.card, this.context === RouteContext.PACKAGE_BUILDER || this.context === RouteContext.SEARCH_BY_VEHICLE || this.context === RouteContext.SEARCH_BY_VEHICLE_FOR_ACCESSORY, false, this.mtlWheelDrillLeadTime).then(value => {
      warningsList = value;
      this.productNotesService.validateProductWarningsAckNormalPopup(warningsList.warnings, null, '', '').then(validated => {
        if (validated && warningsList.proceedToNextStep) {
          // STUDDABLE TIRE
          if (this.card.frontProduct.studdable == "yes" || this.card.frontProduct.studdable == "oui") {
            let studFrontLabours: Product[] = null;
            let studRearLabours: Product[] = null;
            let _y = ['yes', 'oui'];

            const isStuddableFront = _y.includes(this.card.frontProduct.studdable.toLowerCase());
            const isStuddableRear = this.card.rearProduct !== null && _y.includes(this.card.frontProduct.studdable.toLowerCase());

            if (isStuddableFront || isStuddableRear) {
              let studLabour: LabourDetailsDtoResponse = null;

              if (isStuddableFront) {
                var frontStudding = this.card.frontProduct.labours.filter(x => x.details).find(y => y.type.toLowerCase() === 'studding');
                studLabour = frontStudding.details;

                var frontLabourModel = new LabourModel();
                frontLabourModel.labour = frontStudding;
                frontLabourModel.quantity = this.qty;

                studFrontLabours = [];
                studFrontLabours.push(Helper.labourModelToProduct(frontLabourModel));
              }

              //if (isStuddableRear) {
              //  var rearStudding = this.card.rearProduct.labours.filter(x => x.details).find(y => y.type.toLowerCase() === 'studding');

              //  if (studLabour === null)
              //    studLabour = rearStudding.details;

              //  var rearLabourModel = new LabourModel();
              //  rearLabourModel.labour = rearStudding;
              //  rearLabourModel.quantity = this.card.rearProduct.quantity;

              //  studRearLabours = [];
              //  studRearLabours.push(Helper.labourModelToProduct(rearLabourModel));
              //}

              if (studLabour !== null) {
                const price = studLabour.customerPrice;
                const description = studLabour.description;
                const studMsg = this.translateService.instant('FC.ProductWarningsNotes.UpSellStuddable')
                  .replace('[stud_description]', description)
                  .replace('[stud_price]', price.toFixed(2));
                this.productNotesService.validateProductWarningsAckNormalPopup([studMsg], null, 'FC.Popup.Labour.AddStudding', 'FC.Popup.Labour.DeclineStudding').then(validated => {
                  if (validated && warningsList.proceedToNextStep) {
                    const frontProduct = new Product({
                      id: this.hardware.longSKU,
                      warningNotes: this.card.frontProduct.warningNotes,
                      quantity: this.qty,
                      type: Constants.PRODUCT_TYPE_TIRE,
                      pairNo: this.card.pairNo
                    });

                    let arr = [];
                    arr.push(frontProduct);
                    arr.push(studFrontLabours[0]);
                    this.addToCartService.postProductsToCart(arr);
                  } else {
                    if (this.card.productTypeWarning == "Kit")
                      this.productService.postKitToCart(this.hardware.longSKU, this.qty);
                    else
                      this.productService.postProductToCart(this.hardware.longSKU, this.qty, this.card.frontProduct.warningNotes, this.card.pairNo, this.card.productTypeWarning, null);
                  }
                });
              }
            }
          } else { // END - STUDDABLE TIRE
            if (this.card.productTypeWarning == "Kit")
              this.productService.postKitToCart(this.hardware.longSKU, this.qty);
            else
              this.productService.postProductToCart(this.hardware.longSKU, this.qty, this.card.frontProduct.warningNotes, this.card.pairNo, this.card.productTypeWarning, null);
          }
        }
      });
    });
  }

  createProductService(): void {
    switch (this.card.productType) {
      //djb:yagni-not sure why these are commented out (copy/paste)
      //case 'Wheel':
      //  this.productService = this.injector.get<WheelService>(WheelService);
      //  break;
      //case 'Tire':
      //  this.productService = this.injector.get<TireService>(TireService);
      //  break;
      case 'Accessory':
        this.productService = this.injector.get<HardwareService>(HardwareService);
        break;
      case 'Kit':
        this.productService = this.injector.get<PackageKitService>(PackageKitService);
        break;
      case 'Other': // djb-Search by Text
        this.productService = this.injector.get<SearchTextService>(SearchTextService);
        break;
      default:
        alert("No service provider: " + this.card.productType);
    }
  }

	//getKeyCards(keys: string[]): GenericSummaryCardDtoResponse[] {
	//  const results = new Array<GenericSummaryCardDtoResponse>();
	//  if (keys != null) {
	//    this.separatedProducts
	//      .filter(accessoryType => accessoryType.cards.some(c => c.frontProduct.details.details.some(
	//        detail => detail.accessoryType === AccessoryCategory.Keys)))
	//      .forEach(accessoryType => accessoryType.cards
	//        .forEach(c => {
	//          if (keys.some(key => key === c.frontProduct.longSKU)) {
	//            results.push(c);
	//          }
	//        })
	//      );
	//  }
	//  return results;
	//}

  get isMissingMSRP(): boolean {
    let result = false;

    if (this.card.frontProduct.retailPrice === "9999.99")
      result = true;
    else if (this.card.rearProduct && (this.card.rearProduct.retailPrice === "9999.99"))
      result = true;

    return result;
  }

  get isFastcoUser(): boolean {
    return User.isFastcoRole;
  }
}
